import { render, staticRenderFns } from "./propertyType.vue?vue&type=template&id=54839105"
import script from "./propertyType.vue?vue&type=script&lang=js"
export * from "./propertyType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports